import React, { Component } from 'react'
import Img from 'gatsby-image'
import Typist from 'react-typist'

import Logo from '../Logo/Logo'
import MapButton from '../MapButton/MapButton'

import styles from './Map.module.scss'

class Map extends Component {
	state = {isOnMap: false, mapWrapperBottom: '0px'};
	componentWillReceiveProps(nextProps) {
		this.setState({ isOnMap: nextProps.isOnMap })
	}
	_updateDimensions = () => {
  		let maxW = 1000
		let mapWrapper = this.refs.mapWrapper
		if (mapWrapper) {
			let mapW = mapWrapper.offsetWidth > maxW ? maxW : mapWrapper.offsetWidth
			let mapH = mapW / (1920/2406)
			let wH = window.outerHeight

			if (mapW >= maxW) {
				this.setState({mapWrapperBottom: `-${(mapH - wH) / 2}px`})
			}
		}
    };
	componentDidMount() {
		this._updateDimensions()
        window.addEventListener("resize", this._updateDimensions)
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this._updateDimensions)
    }
	render () {
		const {isOnMap} = this.state
		const {bgImage, bgPageImage, places} = this.props
		return (
			<div className={styles.mapContainer}>
				<Img sizes={bgImage.sizes}
				     className={styles.bgImageWrapper}
				     outerWrapperClassName={styles.bgOuterImageWrapper} />				
				<div ref="mapWrapper" className={styles.interactiveMapWrapper} style={{ bottom: this.state.mapWrapperBottom }}>
					<Img sizes={bgPageImage.sizes}
					     className={styles.bgPageImageWrapper}					     
					     outerWrapperClassName={styles.bgPageOuterImageWrapper} />
					<div className={styles.interactiveMapRoads}>
						<svg width="100%" viewBox="0 0 1920 2406" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
						  <g fill="none" fillRule="evenodd" transform="translate(410 720)" className={styles.showupPath} style={{ opacity: isOnMap ? '1' : '0' }}>
						  	<path d="M393.768057,441.381478 C393.768057,441.381478 638.730057,734.400478 344.259057,774.325478 C49.7880573,814.252478 188.519057,865.506478 49.7880573,814.252478 C-88.9439427,762.998478 92.6680573,608.961478 223.832057,602.387478 C354.996057,595.814478 561.832057,625.101478 425.623057,245.578478 C289.414057,-133.944522 727.265057,-18.3525215 612.388057,231.374478 C497.511057,481.102478 606.791057,485.712478 606.791057,485.712478 C606.791057,485.712478 645.259057,172.299478 781.280057,384.696478 C917.301057,597.093478 333.556057,792.286478 218.788057,863.066478 C104.019057,933.845478 443.016057,993.815478 443.016057,993.815478 C443.016057,993.815478 640.590636,1036.64023 781.280057,844.533186 C895.66002,688.350895 721.309011,611.149454 763.164179,699.768779 C834.92787,851.712972 1160.76877,690.32127 1122.02757,485.712478" stroke="#3D1F03" className={styles.path} strokeLinejoin="round" strokeMiterlimit="10" strokeDasharray="11.983 11.983" strokeWidth="3" opacity=".6"></path>
					      </g>
						  <g fill="none" fillRule="evenodd">
						    {
						    	places.map((place, index) => {
						    		return (place.enabled) ? <MapButton key={index} data={place} index={index} isOnMap={isOnMap} /> : ""
						    	})
						    }
						  </g>
						</svg>						
					</div>					
				</div>
				<div className={styles.copyWrapper}>
					<Logo containerClassName={styles.logoContainer} style={{ marginBottom: (isOnMap) ? '-35px' : '10px' }} />
					{ (isOnMap) && <Typist className={styles.typist}
					                       startDelay={800}
					                       cursor={{ blink: true, hideWhenDone: false }}>
					               			Un recorrido sonoro por la obra de José Eustasio Rivera
					               </Typist> }
				</div>
			</div>
		)
	}
}

export default Map


// WEBPACK FOOTER //
// ./src/components/Map/Map.js